import colors, { themeColor } from "./design";

// export const caseStatusValues = ['CREATED', 'MEDIATION', 'EVIDENCE',
// 'ARGUMENT', 'COMPLETED', 'ARCHIVED'];
export const caseStatusValues = [
  "FILING",
  "NOTICE",
  "PLEADINGS",
  "EVIDENCE",
  "ARGUMENTS",
  "COMPLETED",
];

// export const taskStatusValues = ['CREATED', 'IN PROCESS', 'COMPLETED', 'ARCHIVED'];
export const taskStatusValues = [
  "CREATED",
  "IN PROCESS",
  "COMPLETED",
  "EXPIRED",
];

export const noticeStatusValues = [
  "REQUEST RECEIVED",
  "DRAFTING",
  "SENT",
  "NEGOTIATION",
  "COMPLETED",
];

export const caseStatusColors = {
  // CREATED: themeColor(colors.created),
  // MEDIATION: 'pink',
  // EVIDENCE: 'violet',
  // ARGUMENT: 'indigo',
  // COMPLETED: 'green',
  // ARCHIVED: 'gray',
  // CREATED: themeColor(colors.created),
  FILING: "pink",
  NOTICE: "red",
  EVIDENCE: "violet",
  ARGUMENT: "indigo",
  COMPLETED: "green",
  PLEADINGS: "gray",
};

export const noticeStatusColors = {
  // CREATED: themeColor(colors.created),
  // DRAFT: 'pink',
  // SENT: 'violet',
  // NEGOTIATION: 'indigo',
  // CONCLUDED: 'green',
  "REQUEST RECEIVED": "gray",
  DRAFTING: "pink",
  SENT: "violet",
  NEGOTIATION: "indigo",
  COMPLETED: "green",
};

export const noticeTypeColors = {
  // INCOMING: 'green',
  // OUTGOING: 'pink',
  Incoming: "green",
  Outgoing: "pink",
};

export const noticeRequestStatusColors = {
  CREATED: themeColor(colors.created),
  APPROVED: "green",
  REJECTED: "red",
};

export const agreementStatusColors = {
  CREATED: "orange",
  // DRAFT: 'pink',
  // SIGNATURE: 'violet',
  // SIGNED: 'green',
  SENT: "violet",
  DECLINED: "pink",
  PARTIALLYCOMPLETED: "gray",
  COMPLETED: "green",
  CANCELLED: "red",
  "RE-SIGNATURE": "grape",
};

export const AGREEMENT_STATUSES = {
  RE_SIGNATURE: "RE-SIGNATURE",
};

const normalizeAgreementStatus = (status) =>
  String(status || "")
    .trim()
    .toUpperCase()
    .replace(/_/g, "-");

export const getStatusText = (status) => {
  const normalizedStatus = normalizeAgreementStatus(status);
  switch (normalizedStatus) {
    case "CREATED":
      return "intiated";
      break;
    case "REVIEW":
      return "under review";
      break;
    case "APPROVAL":
      return "pending approval";
      break;
    case "SIGNATURE":
      return "finalised";
      break;
    case "SENT":
      return "pending signature";
      break;
    case "CANCELLED":
      return "cancelled";
      break;
    case "RE-SIGNATURE":
      return "Re-finalized";
      break;
    case "SIGNED":
      return "signed";
    case "PARTIALLYCOMPLETED":
      return "Partially completed";
    case "FORCECLOSED":
      return "inactive";
    // Add more cases as needed
    default:
      if (status === "Review") return "under review";
      if (status === "Approval") return "pending approval";
      if (status === "Signature") return "finalised";
      return "under review";
  }
};
export const getStatusColor = (status) => {
  const normalizedStatus = normalizeAgreementStatus(status);
  switch (normalizedStatus) {
    case "CREATED":
      return "yellow";
      break;
    case "REVIEW":
      return "rgba(255, 131, 69, 1)";
      break;
    case "APPROVAL":
      return "pink";
      break;
    case "SIGNATURE":
      return "grape";
      break;
    case "SENT":
      return "violet";
      break;
    case "CANCELLED":
      return "red";
      break;
    case "RE-SIGNATURE":
      return "grape";
      break;
    case "SIGNED":
      return "green";
    case "PARTIALLYCOMPLETED":
      return "indigo";
    case "FORCECLOSED":
      return "pink";
    // Add more cases as needed
    default:
      if (status === "Review") return "rgba(255, 131, 69, 1)";
      if (status === "Approval") return "pink";
      if (status === "Signature") return "grape";
      return "gray";
  }
};

export const taskStatusColors = {
  CREATED: themeColor(colors.created),
  "IN PROCESS": themeColor(colors["in process"]),
  COMPLETED: themeColor(colors.completed),
  // ARCHIVED: 'gray',
  EXPIRED: "red",
};

export const moduleColors = {
  case: themeColor(colors.case),
  agreement: themeColor(colors.agreement),
  notice: themeColor(colors.notice),
  task: themeColor(colors.task),
  cases: themeColor(colors.cases),
  agreements: themeColor(colors.agreements),
  notices: themeColor(colors.notices),
  tasks: themeColor(colors.tasks),
};
